export const talentPoolTitle = 'Talent Pool - application form';
export const talentPoolId = '1e409c';
